/* Pufa Bundle Builder — picker UI. */
(function (root) {
  'use strict';

  // Remove a trailing ".00" (zero decimals only), preserving any currency symbol/spacing.
  // ILS uses a dot decimal separator; this matches the literal ".00" stripped by bundle-money.liquid.
  function stripTrailingZeros(formatted) {
    if (typeof formatted !== 'string') return formatted;
    return formatted.replace(/(\d)\.00(?=\D*$)/, '$1');
  }

  root.PufaBundle = root.PufaBundle || {};
  root.PufaBundle.stripTrailingZeros = stripTrailingZeros;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { stripTrailingZeros };
  }

  if (typeof window === 'undefined') return; // Node test import stops here.

  var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function findForm(el) {
    var id = el.getAttribute('data-form');
    if (id) {
      var byId = document.querySelector('form[id="' + id + '"]');
      if (byId) return byId;
      if (window.console && console.warn) {
        console.warn('[PufaBundle] data-form="' + id + '" not found; falling back to first cart form');
      }
    }
    var pf = document.querySelector('product-form form[action*="/cart/add"]');
    return pf || document.querySelector('form[action*="/cart/add"]');
  }

  // Inject/refresh a hidden input (tagged data-pbb) on the product form.
  function setFormInput(form, name, value) {
    if (!form) return;
    var input = form.querySelector('input[name="' + name + '"][data-pbb="1"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-pbb', '1');
      form.appendChild(input);
    }
    input.value = value;
  }

  function commit(el, row) {
    var form = findForm(el);
    if (!form || !row) return;
    var addMode = el.getAttribute('data-add-mode');
    var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
    var variantId = row.getAttribute('data-variant');

    // Primary variant id (reuse the theme's hidden id input if present).
    // Clear `disabled` like Dawn's product-form constructor does, otherwise an
    // input the theme disabled (unavailable default variant) is dropped from FormData.
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) { idInput.value = variantId; idInput.disabled = false; }
    else { setFormInput(form, 'id', variantId); }

    // Quantity (quantity mode adds qty of the base variant; variant mode adds 1).
    var q = addMode === 'variant' ? 1 : qty;
    var qInput = form.querySelector('input[name="quantity"]');
    if (qInput) { qInput.value = q; } else { setFormInput(form, 'quantity', q); }
  }

  // One-shot scale "bop" on the chosen card — playful selection feedback.
  function bop(row) {
    if (prefersReduced) return;
    row.classList.remove('pbb-bop');
    void row.offsetWidth; // reflow so the animation can restart on re-select
    row.classList.add('pbb-bop');
    row.addEventListener('animationend', function handler(e) {
      if (e.animationName === 'pbb-bop') { row.classList.remove('pbb-bop'); row.removeEventListener('animationend', handler); }
    });
  }

  // Tiny gift/sparkle particles floating up from a bonus tier when picked.
  function burst(row) {
    if (prefersReduced) return;
    var bonus = parseInt(row.getAttribute('data-bonus'), 10) || 0;
    if (bonus <= 0) return;
    var host = row.closest('bundle-builder');
    if (host && host.getAttribute('data-burst-enabled') === '0') return;
    var glyphs = ((host && host.getAttribute('data-burst-emojis')) || '✨,🎁,💖,✨,🎉').split(/[\s,]+/).filter(Boolean);
    if (!glyphs.length) glyphs = ['✨', '🎁', '💖', '✨', '🎉'];
    var burstBase = (host && parseInt(host.getAttribute('data-burst-size'), 10)) || 26;
    for (var i = 0; i < 5; i++) {
      var s = document.createElement('span');
      s.className = 'pbb-burst';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = glyphs[i % glyphs.length];
      // scattered like the dynamic picker burst: random spot/drift/spin/timing/size
      s.style.insetInlineStart = Math.round(8 + Math.random() * 72) + '%';
      s.style.top = Math.round(15 + Math.random() * 55) + '%';
      s.style.setProperty('--pbb-dx', Math.round((Math.random() - 0.5) * 56) + 'px');
      s.style.setProperty('--pbb-rot', Math.round((Math.random() - 0.5) * 56) + 'deg');
      s.style.animationDelay = Math.round(Math.random() * 180) + 'ms';
      s.style.fontSize = Math.round(burstBase + Math.random() * 10) + 'px';
      row.appendChild(s);
      (function (node) {
        setTimeout(function () { if (node.parentNode) { node.parentNode.removeChild(node); } }, 1000);
      })(s);
    }
  }

  function select(el, row, animate) {
    el.querySelectorAll('.pbb-row').forEach(function (r) {
      var on = r === row;
      r.classList.toggle('is-selected', on);
      r.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    commit(el, row);
    if (animate) { bop(row); burst(row); }
  }

  // ---- Decorative capsule cluster (drawn in JS; replaces the old Liquid pyramid). ----
  // Each .pbb-row__capslayer carries data-caps (count), data-cap-colors (3 hex), and
  // data-cap-style. We pack an organic bead cluster jammed into the bottom-left corner
  // of the card, bleeding past the left/bottom edges (clipped by the layer's
  // overflow:hidden). Fewer capsules -> bigger beads. Layout is deterministic per count
  // so it stays stable across reloads. Only the 'cluster' style exists; anything else
  // falls back to it.
  function pbbRng(seed) {
    var s = (seed >>> 0) || 1;
    return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
  }

  // Base row width = smallest W whose triangular number T(W) >= count.
  function capWidth(n) { var W = 1; while (W * (W + 1) / 2 < n) W++; return W; }

  // Draw one tier's heap. Beads stack as a corner pile: widest row on the bottom wall,
  // one fewer each row up, leaning on the left wall, bleeding past both edges. `maxW` is
  // the base width of the densest tier on the card, so "bigger when fewer" is measured
  // against it. Three Theme-editor knobs (read off the layer): data-cap-size (base px),
  // data-cap-delta (% growth toward fewer capsules), data-cap-bleed (% past the wall).
  // Returns the cluster's right edge in px so the caller can reserve clear space for text.
  function drawCapCluster(layer, maxW) {
    var n = parseInt(layer.getAttribute('data-caps'), 10) || 0;
    layer.textContent = ''; // clear any previous beads (also covers resize redraw)
    if (n <= 0) return 0;

    var colors = (layer.getAttribute('data-cap-colors') || '')
      .split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    if (!colors.length) colors = ['#e0b64a', '#bcc1c9', '#c70d38'];

    var size = parseFloat(layer.getAttribute('data-cap-size'));     if (!(size > 0)) size = 18;
    var deltaPct = parseFloat(layer.getAttribute('data-cap-delta')); if (isNaN(deltaPct)) deltaPct = 100;
    var bleedPct = parseFloat(layer.getAttribute('data-cap-bleed')); if (isNaN(bleedPct)) bleedPct = 20;

    var H = layer.clientHeight || 72; // bottom wall = y:H, left wall = x:0
    var rnd = pbbRng(n * 2654435761);
    var W = capWidth(n);

    // Bead diameter: `size` at the densest tier, growing toward fewer capsules by `delta`
    // (delta 0 = every tier identical; 100 = the classic 1/count falloff). Capped at 3x
    // base so a cranked delta can't produce an absurd ball.
    var d = Math.max(8, Math.min(size * 3, size * (1 + (deltaPct / 100) * (maxW / W - 1))));

    var dx = d * 0.84;                  // horizontal centre-to-centre (beads overlap into a pile)
    var dy = d * 0.76;                  // row-to-row rise (rows nestle into the valleys below)
    var bleed = d * (bleedPct / 100);   // how far a corner bead pokes past the wall
    var x0 = d * 0.5 - bleed;           // leftmost centre
    var yb = H - (d * 0.5 - bleed);     // bottom-row centre

    var placed = 0, right = 0;
    for (var r = 0; placed < n; r++) {
      var countR = Math.min(W - r, n - placed);
      if (countR < 1) countR = n - placed; // remainder row for non-triangular counts
      var shift = (r % 2) * (dx * 0.5);    // alternate half-step keeps the left edge on the wall
      var y = yb - r * dy;
      for (var j = 0; j < countR && placed < n; j++, placed++) {
        var cx = x0 + shift + j * dx + (rnd() - 0.5) * d * 0.08;
        var cy = y + (rnd() - 0.5) * d * 0.08;
        var dia = d * (1 - r * 0.04) * (0.94 + rnd() * 0.1); // lower rows a touch bigger (depth)
        if (cx + dia * 0.5 > right) right = cx + dia * 0.5;

        var bead = document.createElement('span');
        bead.className = 'pbb-cap';
        bead.style.setProperty('--cap', colors[placed % colors.length]);
        bead.style.setProperty('--cap-d', dia.toFixed(1) + 'px');
        bead.style.left = cx.toFixed(1) + 'px';
        bead.style.top = cy.toFixed(1) + 'px';
        bead.style.zIndex = String(40 - r); // bottom rows paint in front of higher ones
        layer.appendChild(bead);
      }
    }
    return right;
  }

  function renderCaps(el) {
    var layers = el.querySelectorAll('.pbb-row__capslayer[data-caps]');
    if (!layers.length) return;
    var maxN = 0;
    layers.forEach(function (l) { maxN = Math.max(maxN, parseInt(l.getAttribute('data-caps'), 10) || 0); });
    var maxW = capWidth(maxN);
    var draw = function () {
      var right = 0;
      layers.forEach(function (l) { var x = drawCapCluster(l, maxW); if (x > right) right = x; });
      // Reserve clear space on the cluster side so the text never collides with the beads,
      // whatever the size/delta/bleed settings. Independent of row height, so no RO loop.
      el.style.setProperty('--pbb-cap-reserve', Math.ceil(right + 4) + 'px');
    };
    draw();
    // Redraw on size changes (responsive rows) so the corner stays packed.
    if (!el._pbbCapRO && typeof ResizeObserver !== 'undefined') {
      el._pbbCapRO = new ResizeObserver(draw);
      layers.forEach(function (l) { el._pbbCapRO.observe(l); });
    }
  }

  function init(el) {
    if (el.dataset.pbbInit === '1') return;
    el.dataset.pbbInit = '1';
    renderCaps(el);
    var rows = Array.prototype.slice.call(el.querySelectorAll('.pbb-row'));
    rows.forEach(function (row) {
      row.addEventListener('click', function () { select(el, row, true); });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(el, row, true); }
      });
    });
    var def = el.querySelector('.pbb-row.is-selected') || rows[0];
    if (def) select(el, def, false); // commit default on load (no celebration)
  }

  function initAll() {
    document.querySelectorAll('bundle-builder').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})(typeof window !== 'undefined' ? window : globalThis);
